import clsx from 'clsx';
import React from 'react';

import { TitleSizes } from './constants';
import type { ForYouSectionHeaderProps } from './interfaces';

const ForYouSectionHeader = ({
  highlight,
  subtitle,
  title,
  titleSize = TitleSizes.Small,
}: ForYouSectionHeaderProps) => {
  if (!highlight && !subtitle && !title) {
    return null;
  }

  return (
    <header>
      <span className="hidden font-suisse-intl-mono text-caption-lg font-normal text-primary-magenta sm:block">
        {highlight}
      </span>
      <h2
        className={clsx(
          'm-0 font-suisse-screen text-headline-alt-sm text-grayscale-charcoal sm:text-headline-lg',
          {
            'md:text-headline-alt-lg': titleSize === TitleSizes.Large,
          }
        )}
      >
        {title}
      </h2>
      <p className="mb-0 mt-8 font-suisse-neue text-body-md font-normal sm:text-subheadline-sm">
        {subtitle}
      </p>
    </header>
  );
};

export default ForYouSectionHeader;
